const en_US = {
  restartInterviewButton: "Start over",
  restartInterviewConfirmTitle: "Start a new interview?",
  restartInterviewConfirmDescription: "This will start a new interview from the beginning. Your existing interview records will be kept.",
  restartInterviewCancel: "Cancel",
  restartInterviewFailed: "Unable to restart the interview. Please try again later.",
  restartInterviewLimitReached: "The interview limit has been reached. You cannot start a new interview.",
  restartInterviewClosed: "This interview is closed. You cannot start a new one.",
  restartInterviewCutoff: "The interview deadline has passed. You cannot start a new one.",
  interviewLoading: "Loading interview…",
  interviewLinkInvalid: "Invalid interview link",
  interviewLoadFailed: "Unable to load the interview. Please try again later.",
  interviewRetry: "Try again",
  saveInfoFailed: 'Unable to save your information. Please try again.',
  loadLatestInterviewFailed: 'Unable to load the latest interview record. Please try again.',
  interviewProgressSaved: 'Interview progress will not be lost',
  previousStimulus: 'Previous concept',
  nextStimulus: 'Next concept',
  expandStimulus: 'Expand concept',
  closeStimulusPreview: 'Close concept preview',
  stimulusPreview: 'Concept preview',
  imageTooLarge: 'Image size cannot exceed 10 MB',
  imageFormatJpegPngOnly: 'Only PNG and JPEG images are supported',
  imageFilesOnly: 'Only image files can be uploaded',
  imageUploadFailed: 'Unable to upload the image. Please try again.',
  finalUploadFailed: 'Unable to upload files. Please try again.',
  Welcome: 'Welcome to the interview for',
  StartInterview: 'Start Interview',
  Submit: 'Submit',
  Stoprecording: 'Stop recording',
  Aiinterviewer: 'AIINTERVIEWER',
  AiModeratedInterview: 'AI-MODERATED INTERVIEW',
  TalkToAva: 'Talk to Ava',
  microphoneAccessTitle: 'Allow microphone access',
  microphoneAccessDescription: 'Ava needs your microphone so you can have a natural voice conversation.',
  microphoneAllow: 'Allow microphone',
  microphoneNotNow: 'Not now',
  microphoneConnectedTitle: 'Microphone connected',
  microphoneConnectedDescription: "You're all set. Ava is ready to listen.",
  microphoneDeniedTitle: 'Microphone access needed',
  microphoneDeniedDescription: 'Please allow microphone access in your browser settings, then try again.',
  microphoneTryAgain: 'Try again',
  VoiceAnswer: 'Voice Answer',
  TextAnswer: 'Text Answer',
  StudyMainTitle: "Before the actual interview, we'l do a screening",
  StudyMainTip:
    'Unfortunately, you are not the target group of this interview and cannot participate in this interview',
  // ThankYou: 'Thank You',
  //
  TitleTop: 'YOU ARE INVITED!',
  HeardVoice: 'GET YOUR VOICE HEARD WITH REWARD',
  Sophie: '5-10 mins casual chat with Ava',
  Sponsored: 'Sponsored by Santa Clause🎅',
  Chikkens: 'Start a quick chat and get rewarded', //'₡0.5 ~ 2.5 CHIKKENS',
  Dollars: 'with your unique CHIMOJI', //'$5 ~ 25 DOLLARS',
  // Progress: 'the progress of this chat',
  Congrats: 'CONGRATS!',
  ThankYou: 'Thank you for the insights',

  Identity: 'Pick your identity',

  Refresh: 'Refresh the page won’t lose the progress of this chat',
  Carousel: 'Slight latency might occur due to internet conditions',
  CheckOut: 'Wanna create interviews like this too? Check out ',
  Rewarded:
    'If you want to be rewarded，the interviewer needs to have information about you ',
  InterviewerReward: 'This is the reward from your interviewer ',
  Register: 'Register/sign in as',
  Insighteer: 'INSIGHTEER',
  Reward: 'to get your reward',
  CreatePassword: 'by creating your password to complete registration',
  Becoming: 'Becoming',
  Password: 'Please input your password!',
  ChooseTopic: 'Choose a topic that interests you',
  Awesome: 'Awesome!',
  Rocks: 'ROCKS',
  Followus: 'Follow us',
  Unique: 'This unique CHIMOJI is created with the chat as NFT on blockchain',
  Next: 'NEXT',
  ViewRewards: 'VIEW REWARDS',
  endMeg1: 'Please leave your email here so we can send you the voice playback',
  endMeg2:
    'Please leave your info here to get incentives from the creator of this interview',
  endMeg3: 'Please leave your info here for the creator of this interview',
  endMsg5: 'Please leave your info here to get the ',
  endMsg6: 'result of your MBTI test',
  Done: 'DONE',
  Done1: 'DONE',
  GetIncentives: 'GET INCENTIVES',
  GetStartedFreeNow: 'Get Started Free Now',
  UniqueChimojiNFT: 'Unique Chimoji NFT',
  endMsg4: 'Wanna built your own interview?',
  ResumeInterview: 'Click to resume the interview',
  interviewPausedTitle: 'Interview paused',
  interviewPausedDescription: "Your progress has been saved. You can continue whenever you're ready.",
  resumeInterviewButton: 'Resume interview',
  pauseInterview: 'Pause',
  pauseInterviewConfirmTitle: 'Pause interview?',
  pauseInterviewConfirmContent:
    'Your progress is saved. You can resume the interview later.',
  pauseInterviewConfirmOk: 'Pause',
  pauseInterviewConfirmCancel: 'Continue interview',
  poorConnection: 'Poor connection',
  connectionReconnectingTitle: 'Reconnecting…',
  connectionReconnectingDescription: 'Please keep this page open. Ava is restoring your connection.',
  connectionReconnectedTitle: 'Reconnected',
  connectionReconnectedDescription: 'You are back online. Continuing your interview.',
  connectionDisconnectedTitle: 'Connection lost',
  connectionDisconnectedDescription: 'Your interview progress has been saved.',
  refresh: 'Refresh the page won’t lose the progress',
  voiceSnapshot: 'Voice Snapshot',
  fromInterview: 'From my interview with Ava, an AI Story Curator',
  findMore: 'Find out more on Chikka.ai',
  msg1: 'TEST YOUR MBTI IN 5 MINS BY TALKING TO AVA',
  speaking: 'You are speaking...',
  avaSpeaking: 'Ava is speaking...',
  avaListening: 'Ava listening...',
  stimuliConversationWithAva: "You're in a conversation with Ava",
  stimuliReviewConcepts:
    "Please review the concepts below carefully and answer Ava's questions.",
  stimuliSwipeInstruction: 'Swipe left or right to view all concepts.',
  stimuliFullscreenInstruction: 'Double-click an image to view it full screen.',
  finalUploadTitleFallback: 'Upload files',
  finalUploadInstructionFallback: 'Add files before finishing the interview',
  finalUploadTap: 'Tap to upload',
  finalUploadHelp:
    'Your file helps us better understand your experience.',
  finalUploadLimit: 'Maximum 10 files',
  finalUploadSubmit: 'SUBMIT',
  finalUploadSkip: 'Skip',
  finalUploadWait: 'Please wait for all files to finish uploading',
}
export default en_US
